import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProjectCostPriorityLoader,
    onSaveProjectCostPriority,
    onProjectCostPriorityClose,
} from 'actions/projectCostPriority';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError, initProps } from '../common';

const ProjectCostPriorityAdd = () => {
    const dispatch = useDispatch();
    const addProjectCostPriorityState = useSelector(state => state.projectCostPrioritys.addProjectCostPriorityState);
    const [selectedProjectCostPriority, setSelectedProjectCostPriority] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedProjectCostPriority(initProps());
    }, [addProjectCostPriorityState]);

    // using selectedProjectCostPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectCostPriority changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProjectCostPriority]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProjectCostPriorityField(name, value);
        validateField(name, value);
    };

    const updateSelectedProjectCostPriorityField = (fieldName, value) => {
        const newProjectCostPriority = { ...selectedProjectCostPriority };
        newProjectCostPriority[fieldName] = value;
        setSelectedProjectCostPriority(newProjectCostPriority);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProjectCostPriority));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProjectCostPriorityLoader());
                dispatch(onProjectCostPriorityClose());
                dispatch(onSaveProjectCostPriority(selectedProjectCostPriority));
                setSelectedProjectCostPriority(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProjectCostPriorityClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProjectCostPriority)}
                        {showErrors(formErrors)}
                        {inputFields(selectedProjectCostPriority, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addProjectCostPriorityState}>
            {modalHeader(<IntlMessages id="projectCostPriority.addProjectCostPriority" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="projectCostPriority.addProjectCostPriority" />)}
        </Modal>
    );
};

export default ProjectCostPriorityAdd;


// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd/index.js